import { render, staticRenderFns } from "./category-ope.vue?vue&type=template&id=29ffe3c2&scoped=true&"
import script from "./category-ope.vue?vue&type=script&lang=js&"
export * from "./category-ope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ffe3c2",
  null
  
)

export default component.exports